<template>
  <basic-container id="carManageLog20230814">
    <avue-crud
      :option="option"
      :table-loading="loading"
      v-if="reWrite"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
      </template>
      <template slot="dateRangeSearch">
        <div style="display: flex;">
        <el-date-picker
              style="width:42%;"
              v-model="query.operateTimeStart"
              type="date"

              value-format="yyyy-MM-dd"
              range-separator="到"
              placeholder="开始日期"

            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.operateTimeEnd"
              type="date"

              value-format="yyyy-MM-dd"
              range-separator="到"

              placeholder="结束日期"
            >
            </el-date-picker>
      </div>
      </template>
      <template slot-scope="scope" slot="carManageTypeSearch">
        <el-select
          v-model="carManageType"
          placeholder="操作类型"
          clearable="true"
        >
          <el-option
            v-for="item in carManageTypeList"
            :key="item.key"
            :label="item.label"
            :value="item.key"
          >
          </el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="operatorTypeSearch">
        <el-select
          v-model="operateType"
          placeholder="操作类型"
          clearable="true"
        >
          <el-option
            v-for="item in operateTypeList"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  getList,
} from './carManageLog.js';
import { getSpaceTree } from '@/api/v4ward/carv2/carparkspace';
export default {
  data() {
    return {
      searchForm:{},
      operateType: '',
      operateTypeList: [],
      carManageType: '',
      carManageTypeList: [
        {
          label: '月卡车',
          key: 1
        },
        {
          label: '固定车',
          key: 2
        },
        {
          label: '储值车',
          key: 3
        },
        {
          label: '业主临停车',
          key: 4
        },
      ],
      reWrite: false,
      spaceList: [],
      form: {},
      query: {
        operateTimeStart:'',
        operateTimeEnd:'',
      },
      loading: true,
      tempSpaceName: '',
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      firstDisplayFlag: false,
      option: {
        height: 'auto',
        calcHeight: 50,
        searchShow: true,
        searchMenuSpan: 24,
        tip: true,
        border: true,
        index: true,
        indexLabel: '#',
        viewBtn: true,
        selection: true,
        menuWidth: 100,
        menu: false,
        columnBtn: true,
        refreshBtn: true,
        stripe: true,
        // selectionClearBtn: true,
        column: [
          {
            label: '车场名称',
            type: 'tree',
            prop: 'spaceId',
            hide: true,
            showColumn: false,
            searchSpan: 6,
            search: true,
            clearable: false,
            props: {
              label: 'title',
              value: 'key',
            },
            width: 120,
          },
          {
            label: '车场名称',
            prop: 'spaceName',
            width: 150,
          },
          {
            label: '车牌号',
            prop: 'plateNumber',
            search: true,
            width: 80,
          },
          {
            label: '车辆身份',
            prop: 'carManageType',
            hide: true,
            showColumn: false,
            search: true,
            searchslot:true,
            width: 160,
          },
          {
            label: '车辆身份',
            prop: 'carManageTypeStr',
            width: 100,
          },
          {
            label: '车主姓名',
            prop: 'personName',
            search: true,
            width: 90,
          },
          {
            label: '车主手机',
            prop: 'personPhone',
            search: true,
            width: 120,
          },
          {
            label: '房间',
            prop: 'roomName',
            width: 120,
          },
          {
            label: '操作类型',
            prop: 'operatorTypeStr',
            width: 140,
          },
          {
            label: '操作类型',
            prop: 'operatorType',
            hide: true,
            showColumn: false,
            search: true,
            searchslot:true,
            width: 160,
          },
          {
            label: '操作人',
            prop: 'operatorName',
            width: 100,
          },
          {
            label: '操作时间',
            prop: 'operateTime',
            width: 150,
          },
          {
            label: '操作时间',
            prop: 'dateRange',
            search: true,
            searchslot:true,
            searchRange: true,
            hide: true,
            searchSpan: 12,
            showColumn: false,
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            width: 150,
          },
          {
            label: '操作内容',
            prop: 'operateContent',
          },
        ],
      },
      data: [],
    };
  },
  watch: {
    spaceId() {
      this.temSpaceId = this.form.spaceId;
    },
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.carmonthlog_add, false),
        viewBtn: this.vaildData(this.permission.carmonthlog_view, false),
        delBtn: this.vaildData(this.permission.carmonthlog_delete, false),
        editBtn: this.vaildData(this.permission.carmonthlog_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.option.height = this.bodyHeight - 410;
    getSpaceTree().then((data) => {
      this.spaceList = data.data;
      if (this.spaceList.length > 0) {
        const column = this.findObject(this.option.column, 'spaceId');
        column.dicData = data.data;
        column.searchValue = this.spaceList[0].key;
        this.tempSpaceId = this.spaceList[0].key;
        this.query.spaceId = this.spaceList[0].key;
        this.searchForm.spaceId = this.spaceList[0].key;
        this.$nextTick(() => {
          this.reWrite = true;
        });
      } else {
        this.$nextTick(() => {
          this.reWrite = true;
        });
      }
    });
    this.initOperateTypeList();
  },

  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        document
          .querySelector(
            '#avue-view  div.avue-crud > div.avue-crud__menu > div.avue-crud__right > button:nth-child(3)'
          )
          .addEventListener('click', () => {
            if (this.option.height == this.bodyHeight - 410) {
              this.option.height = this.bodyHeight - 300;
            } else {
              this.option.height = this.bodyHeight - 410;
            }
            this.$refs.crud.getTableHeight();
          });
      }, 1000);
    });
  },
  methods: {
    initOperateTypeList() {
      getDictionary('car_manage_operate_type').then((data) => {
        this.operateTypeList = data.data;
      });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {


      this.query.operateTimeStart=''
        this.query.operateTimeEnd=''
      this.form.spaceId = this.temSpaceId;
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query.spaceId = params.spaceId;
      this.query.plateNumber = params.plateNumber;
      this.query.personName = params.personName;
      this.query.personPhone = params.personPhone;
      this.query.operateType = params.operateType;
      this.query.carManageType = params.carManageType;

      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      if (this.query.dateRange) {
        this.query.operateTimeStart = this.query.dateRange[0];
        this.query.operateTimeEnd = this.query.dateRange[1];
      }
      if (this.query.spaceId == undefined || this.query.spaceId == '') {
        this.query.spaceId = this.tempSpaceId;
      }
      this.query.operateType = this.operateType;
      this.query.carManageType = this.carManageType;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
import { mapGetters } from 'vuex';

import { getDictionary } from '@/api/common';
</script>

<style lang="scss">
#carManageLog20230814 {
  .avue-form__menu--center {
    text-align: right;
  }
  .avue-crud__search .el-form-item--small.el-form-item {
    width: 100%;
  }
}
</style>
